import { Trash2, Plus, Pencil, Users, ChevronDown, LogOut } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import {useOnlineStatusContext} from '../../context/OnlineStatusContext'
import useUserProfile from "../../hooks/useUserProfile";
const ChatHeader = ({
  activeUser,
  admin,
  setShowMembers,
  showMembers,
  groupMembers,
  membersRef,
  userRole,
  handleRemoveMember,
  handleOpenAddMembers,
  setNewGroupName,
  setShowEditGroup,
  setShowExitGroupModal,
  setShowDeleteGroupModal,
  handleDeleteChatHistory
}) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
 
  const menuRef = useRef(null);
  const profile = useUserProfile(activeUser?.id);
  const { onlineUsers } = useOnlineStatusContext();
     console.log("The onlineUsers is:",onlineUsers,profile?.id)
  const isOnline = onlineUsers.has(profile?.id?.toString());
  // const lastSeen = lastSeenMap[profile?.id?.toString()];
  console.log("The active user is:",activeUser)


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMobileMenu(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close mobile menu on window resize to larger screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setShowMobileMenu(false);
      }
    };
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="w-full p-3 md:p-4 border-b border-gray-100 rounded-tr-[10px] bg-white">
      <div className="flex items-center justify-between">
        {/* Left Side: User/Group Info */}
        <div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0">
          <div className="relative flex-shrink-0">
            <img
              src={
                activeUser.profile_picture ||
                activeUser.profile_image ||
                admin
              }
              className="w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl object-cover ring-2 ring-white shadow-sm"
              alt={activeUser.name}
            />
           {!activeUser.is_group && (
  <div
    className={`absolute -bottom-1 -right-1 w-2.5 h-2.5 md:w-3.5 md:h-3.5 rounded-full border-2 border-white ${
      activeUser?.online_status ? 'bg-green-500' : 'bg-gray-400'
    }`}
  ></div>
)}

          </div>
          
          <div className="flex flex-col flex-1 min-w-0">
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <div>
                <h3 className="font-semibold text-gray-900 text-sm md:text-base truncate">
                {activeUser.name}
              </h3>
               {/* Show online status for non-group users */}
    {!activeUser.is_group && (
      <span className="text-xs text-gray-500 mt-[-3px]">
        {activeUser.last_seen_display}
      </span>
    )}
              </div>
              
              {activeUser.is_group && (
                <div className="relative flex-shrink-0">
                  {/* Desktop Version */}
                  <div className="hidden md:block">
                    <button
                      className="flex items-center gap-1.5 px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-sm font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors whitespace-nowrap"
                      onClick={() => setShowMembers(!showMembers)}
                    >
                      <Users size={14} />
                      <span>{groupMembers.length} members</span>
                      <ChevronDown 
                        size={14} 
                        className={`transition-transform ${showMembers ? 'rotate-180' : ''}`} 
                      />
                    </button>
                  </div>
                  
                  {/* Mobile Version - Simplified */}
                  <div className="md:hidden">
                    <button
                      className="flex items-center gap-1 px-2 py-1 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors whitespace-nowrap"
                      onClick={() => setShowMembers(!showMembers)}
                    >
                      <Users size={12} />
                      <span>{groupMembers.length}</span>
                    </button>
                  </div>

                  {/* Members Dropdown */}
                  {showMembers && (
                    <div
                      className="absolute top-full left-0 md:left-auto md:right-0 mt-2 bg-white rounded-lg md:rounded-xl shadow-lg border border-gray-200 w-full md:w-64 max-h-60 md:max-h-80 overflow-y-auto z-50"
                      ref={membersRef}
                    >
                      <div className="p-2 md:p-3 border-b border-gray-100">
                        <h4 className="font-semibold text-gray-900 text-sm">Group Members</h4>
                        <p className="text-xs text-gray-500 mt-0.5">{groupMembers.length} total members</p>
                      </div>
                      
                      <div className="p-1 md:p-2">
                        {groupMembers.map((m) => (
                          <div key={m.user.id} className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50 transition-colors">
                            <div className="flex items-center gap-2 flex-1 min-w-0">
                              <img
                                src={m.user.profile_picture || admin}
                                alt={m.user.name}
                                className="w-7 h-7 md:w-8 md:h-8 rounded-full object-cover"
                              />
                              <div className="flex-1 min-w-0">
                                <div className="flex flex-col md:flex-row md:items-center gap-0.5 md:gap-1.5">
                                  <span className="text-xs md:text-sm font-medium text-gray-900 truncate">
                                    {m.user.name}
                                  </span>
                                  {m.role === "creator" && (
                                    <span className="px-1.5 py-0.5 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded whitespace-nowrap">Creator</span>
                                  )}
                                  {m.role === "admin" && (
                                    <span className="px-1.5 py-0.5 bg-gray-100 text-gray-700 text-xs font-medium rounded whitespace-nowrap">Admin</span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {(userRole === "admin" || userRole === "creator") &&
                              m.user.id !== activeUser.created_by?.id && (
                                <button
                                  onClick={() => handleRemoveMember(m.user.id)}
                                  className="p-1 md:p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors ml-1 md:ml-2 flex-shrink-0"
                                  title="Remove member"
                                >
                                  <Trash2 size={12} className="md:w-3.5 md:h-3.5" />
                                </button>
                              )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            
            {activeUser.is_group && (
              <p className="text-xs text-gray-500 mt-0.5 hidden md:block">
                Group • Last active recently
              </p>
            )}
          </div>
        </div>

        {/* Right Side: Actions */}
        <div className="flex items-center gap-1 md:gap-2">
          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-2">
            {activeUser.is_group && (
              <div className="flex items-center gap-2 mr-2">
                {(userRole === "admin" || userRole === "creator") && (
                  <>
                    <button
                      className="w-10 h-10 bg-[#0f6abf] text-white rounded-xl flex items-center justify-center hover:bg-[#0a5ca8] transition-colors"
                      onClick={() => handleOpenAddMembers(activeUser)}
                      title="Add members"
                    >
                      <Plus size={18} />
                    </button>
                    
                    <button
                      className="w-10 h-10 bg-gray-100 text-gray-700 rounded-xl flex items-center justify-center hover:bg-gray-200 transition-colors"
                      onClick={() => {
                        setNewGroupName(activeUser.name);
                        setShowEditGroup(true);
                      }}
                      title="Edit group"
                    >
                      <Pencil size={16} />
                    </button>
                  </>
                )}

                {userRole === "member" && (
                  <button
                    className="px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-xl hover:bg-red-600 transition-colors flex items-center gap-1.5"
                    onClick={() => setShowExitGroupModal(true)}
                  >
                    <LogOut size={14} />
                    Exit
                  </button>
                )}

                {(userRole === "admin" || userRole === "creator") && (
                  <button
                    className="px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-xl hover:bg-red-600 transition-colors flex items-center gap-1.5"
                    onClick={() => setShowDeleteGroupModal(true)}
                  >
                    <Trash2 size={14} />
                    Delete
                  </button>
                )}
              </div>
            )}

            <button
              className="w-10 h-10 bg-gray-100 text-gray-700 rounded-xl flex items-center justify-center hover:bg-red-50 hover:text-red-500 transition-colors"
              onClick={handleDeleteChatHistory}
              title="Clear chat"
            >
              <Trash2 size={16} />
            </button>
          </div>

          {/* Mobile Actions - Hamburger Menu */}
          <div className="md:hidden relative" ref={menuRef}>
            <button
              className="w-8 h-8 bg-gray-100 text-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-200 transition-colors"
              onClick={() => setShowMobileMenu(!showMobileMenu)}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
              </svg>
            </button>

            {/* Mobile Dropdown Menu */}
            {showMobileMenu && (
              <div className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border border-gray-200 w-48 py-1 z-50">
                {activeUser.is_group && (
                  <>
                    {(userRole === "admin" || userRole === "creator") && (
                      <>
                        <button
                          className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                          onClick={() => {
                            handleOpenAddMembers(activeUser);
                            setShowMobileMenu(false);
                          }}
                        >
                          <Plus size={14} />
                          Add Members
                        </button>
                        
                        <button
                          className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                          onClick={() => {
                            setNewGroupName(activeUser.name);
                            setShowEditGroup(true);
                            setShowMobileMenu(false);
                          }}
                        >
                          <Pencil size={14} />
                          Edit Group
                        </button>
                      </>
                    )}

                    {userRole === "member" && (
                      <button
                        className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                        onClick={() => {
                          setShowExitGroupModal(true);
                          setShowMobileMenu(false);
                        }}
                      >
                        <LogOut size={14} />
                        Exit Group
                      </button>
                    )}

                    {(userRole === "admin" || userRole === "creator") && (
                      <button
                        className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                        onClick={() => {
                          setShowDeleteGroupModal(true);
                          setShowMobileMenu(false);
                        }}
                      >
                        <Trash2 size={14} />
                        Delete Group
                      </button>
                    )}
                    
                    <div className="border-t border-gray-200 my-1"></div>
                  </>
                )}

                <button
                  className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                  onClick={() => {
                    handleDeleteChatHistory();
                    setShowMobileMenu(false);
                  }}
                >
                  <Trash2 size={14} />
                  Clear Chat
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Mobile Group Status */}
      {activeUser.is_group && (
        <p className="text-xs text-gray-500 mt-1 md:hidden">
          Group • {groupMembers.length} members
        </p>
      )}
    </div>
  );
};

export default ChatHeader;